// extracted by mini-css-extract-plugin
export default {"faq_container":"faq_faq_container__FhA75"};